/**
 *
 * MobileComponent
 *
 */
import React, { memo } from 'react';
import styled from 'styled-components/macro';
import { Field } from 'formik';
import { DropDown } from 'libs/DropDown';
import classNames from 'classnames';
import { Country } from 'core/utils/types/modules/org';
import { Input } from 'core/components/Input';
import { noSpecial, numOnly } from 'core/utils/constants/regex';

interface Props {
  countryCodeName?: string;
  numberName?: string;
  countryList: Country[];
  defaultCCValue?: any;
  onDropdownChange?: any;
  inputValue: any;
  setcountryCodes?:
  | React.Dispatch<React.SetStateAction<Country[]>>
  | React.Dispatch<React.SetStateAction<Country[] | undefined>>;
  messageCC?: any;
  errorCC?: any;
  errorMobile?: any;
  messageMobile?: any;
  codeWidth?: any;
  label?: string;
  placeHolder?: string;
  labelClassName?: string;
  extraLabel?: any;
  extraMobileOnChange?: any;
  extraCountryCodeOnChange?: any;
  restrictCopyPaste?: boolean;
  disabled?: boolean;
  toggleLabel?: React.ReactNode;
}

export const MobileComponent = memo((props: Props) => {
  const defaultCountryCode = '+91'; // Set your default country code here
  const [isChecked, setIsChecked] = React.useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  // Check if props.defaultCCValue is not provided or empty
  const defaultCCValue = props.defaultCCValue || props.countryList.find(
    item => item.COUNTRY_CODE == defaultCountryCode
  );
  return (
    <div className="grid grid-cols-12 items-end gap-x-2">
      <div className={`col-span-${props?.codeWidth || 3}`}>
        <Field name={props.countryCodeName || 'COUNTRY_CODE'}>
          {({ field, form, meta }) => (
            <DropDown
              onBlur={field.onBlur}
              name={props.countryCodeName || 'COUNTRY_CODE'}
              getOptionValue={(option: Country) => option.COUNTRY_CODE}
              getOptionLabel={(option: Country) => `${option.COUNTRY_CODE}`}
              
              options={props.countryList}
              placeholder="Select"
              isDisabled={false}
              onChange={(item: Country) => {
                if (props?.extraCountryCodeOnChange) {
                  props?.extraCountryCodeOnChange(item.COUNTRY_CODE)
                } else {
                  form.setFieldValue(field.name, item.COUNTRY_CODE)
                }

              }
              }
              label={`${props?.label ? props?.label : 'Mobile Number'}`}
              width="my-2"
              required
              defaultValue={defaultCCValue}
            />
          )}
        </Field>
      </div>
      <div className={`col-span-${!!props?.codeWidth ? (12 - props?.codeWidth) : 9}`}>
        <Field name={props.numberName || 'MOBILE_NUMBER'}>
          {({ field, form, meta }) => (
            <Input
              type='text'
              name={props.numberName || 'MOBILE_NUMBER'}
              label={props.toggleLabel ? props.toggleLabel : (props?.extraLabel || "")}
              disabled={props.disabled}
              placeholder={`${props?.placeHolder ? props?.placeHolder : `Enter Mobile Number`}`}
              onChange={e => {
                if (props?.extraMobileOnChange) {
                  props?.extraMobileOnChange(e)
                } else {
                  field.onChange(e)
                }
              }}
              allowOnlyNumbers={true}
              value={props.inputValue}
              // required
              onBlur={field.onBlur}
              requiredlabelClassName={`text-neutral-light`}
              labelClassName={`${!!props?.labelClassName ? props?.labelClassName : ""}`}

              restrictCopyPaste={props?.restrictCopyPaste}
            />
          )}
        </Field>
      </div>
      <div className="col-span-12">
        {props.messageCC && (
          <span
            className={classNames(
              `${props.errorCC ? 'text-secondary-red' : 'text-neutral-50'}
        mt-[4px] text-xs
        `,
            )}
          >
            {props.messageCC}
          </span>
        )}
        {props.messageMobile && (
          <div
            className={classNames(
              `${props.errorMobile ? 'text-secondary-red' : 'text-neutral-50'}
        mt-[4px] text-xs
        `,
            )}
          >
            {props.messageMobile}
          </div>
        )}
      </div>
    </div>
  );
});

const Div = styled.div``;
